export default __webpack_public_path__ + "static/media/CTOInactiveTab.d6570f71.svg";